import { render } from "./App.vue?vue&type=template&id=57b09e28"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=57b09e28&lang=less"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/collections/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__